// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-layout-new[data-v-fea6615e]{min-height:100vh;display:flex;flex-direction:column;background:#f9f9f9;background:var(--page-layout-bg,#f9f9f9)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
